export default "__VITE_ASSET__J8QAv5vr__"